import { navLinks, siteInfo } from '@/mocks/chigua';

export default function Footer() {
  return (
    <>
      <footer className="bg-secondary-700 text-background-50">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
          <div className="grid gap-10 md:grid-cols-[1.2fr_0.8fr_1fr]">
            <div>
              <div className="flex items-center gap-2.5">
                <span className="grid h-10 w-10 place-items-center rounded-md bg-primary-400 font-heading text-xl font-black text-accent-950">
                  瓜
                </span>
                <span className="font-heading text-2xl font-black">{siteInfo.name}</span>
              </div>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-100">{siteInfo.intro}</p>
              <div className="mt-5 flex gap-2">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-fill', 'ri-rss-fill'].map((ic, i) => (
                  <a
                    key={i}
                    href="#"
                    aria-label="关注我们"
                    className="grid h-9 w-9 cursor-pointer place-items-center rounded-full bg-accent-700/40 text-secondary-100 transition-colors hover:bg-accent-500 hover:text-accent-950"
                  >
                    <i className={ic}></i>
                  </a>
                ))}
              </div>
            </div>

            <nav aria-label="栏目导航">
              <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-secondary-100">快速导航</h4>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
                {navLinks.map((n) => (
                  <li key={n.href}>
                    <a
                      href={n.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(n.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="cursor-pointer text-sm text-secondary-100 transition-colors hover:text-background-50"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-secondary-100">联系方式</h4>
              <ul className="mt-4 space-y-3 text-sm text-secondary-100">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>melongarden@chigua.example</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  <span>编辑室每日 10:00 - 22:00 在线</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-question-line"></i>
                  <a
                    href="#faq"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="cursor-pointer underline-offset-4 hover:underline"
                  >
                    常见问题与投稿说明
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-accent-900/40 pt-6 text-xs text-secondary-200 sm:flex-row">
            <p>
              © {new Date().getFullYear()} {siteInfo.name} · 仅供娱乐交流，内容整理自公开可查信息，观点不代表本频道立场。
            </p>
            <div className="flex items-center gap-4">
              <a href="#top" className="cursor-pointer hover:text-background-50">回到顶部</a>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-400"></i> 证据导向 · 不造谣
              </span>
            </div>
          </div>
        </div>
      </footer>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="回到顶部"
        className="fixed bottom-6 right-6 z-40 grid h-11 w-11 cursor-pointer place-items-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:-translate-y-1"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </>
  );
}